var render, staticRenderFns
import script from "./MainImage.vue?vue&type=script&lang=js&"
export * from "./MainImage.vue?vue&type=script&lang=js&"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=17999db3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17999db3",
  null
  
)

export default component.exports